import { render } from "./PsaWorkflowRules.vue?vue&type=template&id=6e16988b&scoped=true"
import script from "./PsaWorkflowRules.vue?vue&type=script&lang=js"
export * from "./PsaWorkflowRules.vue?vue&type=script&lang=js"

import "./PsaWorkflowRules.vue?vue&type=style&index=0&id=6e16988b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e16988b"]])

export default __exports__